function urlBase64ToUint8Array(base64String) {
    var padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    var base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");

    var rawData = window.atob(base64);
    var outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

let newWorker;
// Register service worker to control making site work offline
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/sw.js", {
            scope: "./",
        })
        .then((serviceWorkerRegistration) => {
            // console.log("serviceWorkerRegistration", serviceWorkerRegistration, navigator.serviceWorker);
            serviceWorkerRegistration.addEventListener("updatefound", () => {
                // console.log("updatefound");
                // An updated service worker has appeared in serviceWorkerRegistration.installing!
                newWorker = serviceWorkerRegistration.installing;
                newWorker.addEventListener("statechange", () => {
                    // Has service worker state changed?
                    // console.log("newWorker.state", newWorker.state);
                    switch (newWorker.state) {
                        case "installed":
                            // There is a new service worker available, show the notification
                            if (navigator.serviceWorker.controller) {
                                if (Notification.permission === "granted") {
                                    navigator.serviceWorker.getRegistration().then(function (reg) {
                                        // console.log("reg", reg);
                                        // serviceWorkerRegistration.showNotification("Test SW.", {
                                        //     data: {url: "/"},
                                        // });
                                    });
                                }
                            }
                            break;
                    }
                });
                // sometime later…
                // serviceWorkerRegistration.update();
            });
            // console.log("sw-reg", reg);
            // serviceWorkerRegistration.pushManager.subscribe({
            //     userVisibleOnly: true,
            //     applicationServerKey: urlBase64ToUint8Array(
            //         "BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuBkr3qBUYIHBQFLXYp5Nksh8U",
            //     ),
            // }).then((pushSubscription) => {
            //         console.log(pushSubscription.subscriptionId);
            //         console.log(pushSubscription.endpoint);
            //         // The push subscription details needed by the application
            //         // server are now available, and can be sent to it using,
            //         // for example, the fetch() API.
            //     },
            //     (error) => {
            //         // During development it often helps to log errors to the
            //         // console. In a production environment it might make sense to
            //         // also report information about errors back to the
            //         // application server.
            //         console.error(error);
            //     },
            // );
        })
        .catch(function (error) {
            console.log("Registration failed: ", error);
        });
    // const firebaseConfig = useStorage("firebaseConfig", {
    //     apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    //     authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
    //     projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    //     storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebasestorage.app`,
    //     messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    //     appId: import.meta.env.VITE_FIREBASE_APP_ID,
    //     measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
    // });
    // const encodedFirebaseConfig = encodeURIComponent(JSON.stringify(firebaseConfig.value));
    // console.log(firebaseConfig);
    //
    // navigator.serviceWorker.register(`/firebase-messaging-sw.js?firebaseConfig=${encodedFirebaseConfig}`);
}
